<template>
  <div id="Skills">
    <Paragraph>
      <small>
        Listing only technologies I work with the most. Get in touch to learn
        more.
      </small>
    </Paragraph>

    <ul class="Skills__grid">
      <li>
        <Html5Icon :width="iconWidth" />
      </li>
      <li>
        <CSS3Icon :width="iconWidth" />
      </li>
      <li>
        <JavascriptIcon :width="iconWidth" />
      </li>
      <li>
        <ReactIcon :width="iconWidth" />
      </li>
      <li>
        <NodejsIcon :width="iconWidth" />
      </li>
      <li>
        <PythonIcon :width="iconWidth" />
      </li>
    </ul>

    <Paragraph>
      <small>Recently interested in</small>
    </Paragraph>

    <ul class="Skills__grid">
      <li>
        <HaskellIcon :width="iconWidth" />
      </li>
      <li>
        <SvelteIcon :width="iconWidth" />
      </li>
      <li>
        <VueIcon :width="iconWidth" />
      </li>
    </ul>
  </div>
</template>

<script>
import {
  Paragraph,
  JavascriptIcon,
  ReactIcon,
  NodejsIcon,
  PythonIcon,
  Html5Icon,
  CSS3Icon,
  SvelteIcon,
  VueIcon,
  HaskellIcon
} from "./index";

export default {
  name: "Skills",
  components: {
    SvelteIcon,
    VueIcon,
    Paragraph,
    JavascriptIcon,
    ReactIcon,
    NodejsIcon,
    PythonIcon,
    Html5Icon,
    CSS3Icon,
    HaskellIcon
  },
  data: function() {
    return {
      iconWidth: 48
    };
  }
};
</script>

<style lang="scss" scoped>
ul.Skills__grid {
  display: grid;
  padding-left: 0;
  margin-top: -10px;
  grid-template-columns: repeat(auto-fill, minmax(64px, 1fr));

  list-style-type: none;

  li {
    margin-top: 10px;
    display: flex;
    align-items: center;
  }
}
</style>
